class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      checkCartAndAddItem();
      //this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

  //Upsell custom code
  
let productsToCheck = [
  { parent_id: 9643064951074, product_id: 9644530794786, variant_id: 49667943989538 }
];

  
async function checkCartAndAddItem() {
  $('button[name="add"][type="submit"]').attr('data-state', 'loading');
  console.log('Démarrage de checkCartAndAddItem');
  let itemDontExist = false;
  fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText);
      }
      return response.json();
    })
    .then(data => {
      console.log('Données reçues pour checkCartAndAddItem');
      productsToCheck.some(product_bundle => {
        const itemExists = data.items.some(item => item.product_id === product_bundle.parent_id);
        if (itemExists) {
          console.log(product_bundle.parent_id+' existe dans le panier');
          const equivalentExists = data.items.some(item => item.id === product_bundle.variant_id);
          if(product_bundle.product_id !== null){
            console.log('Upsell existe pour '+product_bundle.parent_id);
            if (!equivalentExists) {
              console.log(product_bundle.variant_id+' n\'existe pas dans le panier. Ajout en cours...');
              // Créer un nouvel élément FormData pour ajouter le produit équivalent
              let addToCartForm = new FormData();
              addToCartForm.append('quantity', '1');
              addToCartForm.append('form_type', 'product');
              addToCartForm.append('product-id', product_bundle.product_id);
              addToCartForm.append('id', product_bundle.variant_id);
  
              // Ajouter le produit équivalent au panier
              fetch('/cart/add.js', {
                method: 'POST',
                body: addToCartForm
              })
              .then(response => response.json())
              .then(data => {
                console.log(`Produit équivalent ajouté au panier: ${product_bundle.variant_id}`, data);
                reloadPageContent();
              })
              .catch(error => {
                console.error(`Erreur lors de l'ajout du produit équivalent ${product_bundle.variant_id} au panier:`, error);
                openCartDrawer();
              });
            } 
            else {
              openCartDrawer();
              console.log('Response: Upsell exists in the cart.');
            }
          }
          else{
            openCartDrawer();
            console.log(`${product_bundle.parent_id} n'a aucun upsell configuré`, data);
          }
          itemDontExist = false;
          return true; // Sortir de la boucle `some()` si l'élément existe
        }
        else{
          itemDontExist = true;
        }
      });
      if(itemDontExist){
        openCartDrawer();
      }
    })
    .catch(error => {
      console.error('Erreur lors de la récupération des données du panier:', error);
    });
}

async function checkCartAndAddItemForV6() {
  $('button[name="add"][type="submit"]').attr('data-state', 'loading');
  console.log('Démarrage de checkCartAndAddItem');
  let itemDontExist = false;
  fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText);
      }
      return response.json();
    })
    .then(data => {
      console.log('Données reçues pour checkCartAndAddItem');
      productsToCheck.some(product_bundle => {
        const itemExists = data.items.some(item => item.product_id === product_bundle.parent_id);
        if (itemExists) {
          console.log(product_bundle.parent_id+' existe dans le panier');
          const equivalentExists = data.items.some(item => item.id === product_bundle.variant_id);
          if(product_bundle.product_id !== null){
            console.log('Upsell existe pour '+product_bundle.parent_id);
            if (!equivalentExists) {
              console.log(product_bundle.variant_id+' n\'existe pas dans le panier. Ajout en cours...');
              // Créer un nouvel élément FormData pour ajouter le produit équivalent
              let addToCartForm = new FormData();
              addToCartForm.append('quantity', '1');
              addToCartForm.append('form_type', 'product');
              addToCartForm.append('product-id', product_bundle.product_id);
              addToCartForm.append('id', product_bundle.variant_id);
  
              // Ajouter le produit équivalent au panier
              fetch('/cart/add.js', {
                method: 'POST',
                body: addToCartForm
              })
              .then(response => response.json())
              .then(data => {
                console.log(`Produit équivalent ajouté au panier: ${product_bundle.variant_id}`, data);
                reloadPageContent();
              })
              .catch(error => {
                console.error(`Erreur lors de l'ajout du produit équivalent ${product_bundle.variant_id} au panier:`, error);
                reloadPageContent();
              });
            } 
            else {
              reloadPageContent();
              console.log('Response: Upsell exists in the cart.');
            }
          }
          else{
            reloadPageContent();
            console.log(`${product_bundle.parent_id} n'a aucun upsell configuré`, data);
          }
          itemDontExist = false;
          return true; // Sortir de la boucle `some()` si l'élément existe
        }
        else{
          itemDontExist = true;
        }
      });
      if(itemDontExist){
        reloadPageContent();
      }
    })
    .catch(error => {
      console.error('Erreur lors de la récupération des données du panier:', error);
    });
}

let isReloading = false; // Empêche les exécutions multiples

async function reloadPageContent() {
    if (isReloading) return;
    isReloading = true;

    try {
        // ✅ Utiliser l'API Sections (beaucoup plus rapide que window.location.href)
        const response = await fetch('/?sections=cart-drawer,cart-icon-bubble');
        const sections = await response.json();

        // Mettre à jour le drawer
        if (sections['cart-drawer']) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
            
            const newCartDrawer = doc.querySelector('cart-drawer');
            const currentCartDrawer = document.querySelector('cart-drawer');

            if (newCartDrawer && currentCartDrawer) {
                const wasActive = currentCartDrawer.classList.contains('active');
                currentCartDrawer.outerHTML = newCartDrawer.outerHTML;
                
                if (wasActive) {
                    const drawer = document.querySelector('cart-drawer');
                    if (drawer) {
                        drawer.classList.add('animate', 'active');
                        document.body.classList.add('overflow-hidden');
                    }
                }
            }
        }

        // Mettre à jour l'icône
        if (sections['cart-icon-bubble']) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
            
            const newCartIcon = doc.querySelector("#cart-icon-bubble");
            const currentCartIcon = document.querySelector("#cart-icon-bubble");

            if (newCartIcon && currentCartIcon) {
                currentCartIcon.outerHTML = newCartIcon.outerHTML;
            }
        }

        // Réattacher les événements
        setTimeout(() => {
            const cartIcon = document.querySelector("#cart-icon-bubble");
            if (cartIcon) {
                cartIcon.addEventListener("click", function (event) {
                    event.preventDefault();
                    openCartDrawer();
                });
            }

            const drawer = document.querySelector('cart-drawer');
            if (drawer && !drawer.classList.contains('active')) {
                openCartDrawer();
            }
        }, 50);

    } catch (error) {
        console.error('Erreur de rechargement du panier :', error);
    } finally {
        // ✅ Réduire de 500ms à 100ms
        setTimeout(() => isReloading = false, 100);
    }
}

function updateBodyOverflow() {
    const body = document.querySelector("body");
    const cartDrawer = document.querySelector("cart-drawer");

    if (cartDrawer && cartDrawer.classList.contains("active")) {
        body.style.setProperty('overflow', 'hidden', 'important');
        body.style.setProperty('height', '100vh', 'important');
    } else {
        body.style.removeProperty('overflow');
        body.style.removeProperty('height');
    }
}

function observeCartDrawer() {
    const cartDrawer = document.querySelector("cart-drawer");

    if (cartDrawer) {
        const observer = new MutationObserver(() => {
            updateBodyOverflow();
        });

        observer.observe(cartDrawer, { attributes: true, attributeFilter: ["class"] });
    }
}

function openCartDrawer() {
    console.log('Opening the cart drawer.');
    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer) {
        $('button[name="add"][type="submit"]').attr('data-state', 'idle');
        cartDrawer.open();
        /*
        const upsellIds = [1, 2, 3];
        executeUpsellsWithDelay(upsellIds, 500);
        insuranceUpsell();
        */
    } else {
        console.log('Cart drawer not found.');
    }
}


document.addEventListener('click', function(event) {
  // Vérifie si l'élément cliqué est un lien qui commence par /cart
  const target = event.target;
  if (target.tagName === 'A' && target.getAttribute('href').startsWith('/cart')) {
    // Empêche le comportement par défaut du lien
    event.preventDefault();
    openCartDrawer();
  }
});